import { render, staticRenderFns } from "./TurnoverOverviewTable.vue?vue&type=template&id=848d8148&scoped=true&"
import script from "./TurnoverOverviewTable.vue?vue&type=script&lang=js&"
export * from "./TurnoverOverviewTable.vue?vue&type=script&lang=js&"
import style0 from "./TurnoverOverviewTable.vue?vue&type=style&index=0&id=848d8148&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "848d8148",
  null
  
)

export default component.exports